import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';

export const SPINNER_SIZE = grid.multiple(6);
const loadingRootLeft = `calc(50% - ${SPINNER_SIZE.multiple(0.5).px})`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoadingRoot = styled.div<{ isRelative?: boolean }>`
    left: ${loadingRootLeft};
    top: ${(props) => (props.isRelative ? token('space.200', '16px') : grid.multiple(9).px)};
    position: ${(props) => (props.isRelative ? 'relative' : 'absolute')};
`;
